import StoreUtil from "../store.util.js";
const mutations = {
  SET_ALL_USERS(state, payload) {
    state.usersList = StoreUtil.updateState(state.usersList, payload);
  },
};

export default mutations;
